
module.exports = require('./lib/jquery-deferred');


//////////////////
// WEBPACK FOOTER
// ./node_modules/mb-app-common/node_modules/jquery-deferred/index.js
// module id = 1940
// module chunks = 1